import React, { FC, useMemo } from 'react';
import classnames from 'classnames';
import { Heading } from '../../index';
import { IOuter } from './FileLabeledThumbnail.types';
import styles from './FileLabeledThumbnail.scss';

export const FileLabeledThumbnail: FC<IOuter> = ({
  className,
  labelClassName,
  label,
  width = 150,
  height = 150,
  dataHook = 'labeled-thumbnail',
  style,
}) => {
  const isLabelVisible = label && label !== '.';

  const wrapperStyle = useMemo(() => ({ width, height, ...style }), [width, height, style]);

  return (
    <div className={classnames(styles.labeledThumbnail, className)} style={wrapperStyle} data-hook={dataHook}>
      {isLabelVisible && (
        <Heading size="extraTiny" className={classnames(styles.formatLabel, labelClassName)} dataHook="thumbnail-label">
          {label}
        </Heading>
      )}
    </div>
  );
};
